export default function setDescriptionTabs() {
  const descriptionTabs = document.querySelectorAll('[data-description-tab]');

  if (descriptionTabs.length > 0) descriptionTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tab.classList.toggle('-open');
        const contentWrapper = tab.parentElement.querySelector('.tab-content');
        contentWrapper.classList.toggle('-open');
      })
  })
}
